var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"px-logo",attrs:{"id":"px-logo-box"}},[_c('canvas',{attrs:{"id":"px-logo"}}),_c('span',{staticClass:"label beta"})])])}
var staticRenderFns = []

export { render, staticRenderFns }